import React from "react"
import {Stack, Typography} from "@mui/material"
import UnterobjektToWidget from "./UnterobjektToWidget"

const FrageListWidget = ({widget, value = []}) => {
    const questionaire = value ?? widget?.questionaire?.origin
    const sections =
        questionaire?.type === "leafNode"
            ? [questionaire]
            : (questionaire?.children ?? [])

    return sections.map((unterobjekt) => (
        <Stack
            spacing={2}
            key={`${unterobjekt.id}${unterobjekt.pointer}`}>
            {unterobjekt?.longname ? (
                <Typography variant="h2">{unterobjekt?.longname}</Typography>
            ) : (
                <></>
            )}
            <UnterobjektToWidget
                widget={widget}
                unterobjekt={unterobjekt}
                sections={sections}
            />
        </Stack>
    ))
}

export default FrageListWidget
